
window.html2canvas = require('html2canvas/dist/html2canvas');

import Chart from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';

window.Chart = Chart;
window.ChartDataLabels = ChartDataLabels;

window.background      = [];
window.rgbcolor        = [];
window.financialCharts = [];

background['purple_b'    ] = '#3D45AE';
background['purple_bdot' ] = '#3D45AE';
background['purple_l'    ] = '#7583FF';
background['purple_ldot' ] = '#7583FF';
background['green_b'     ] = `#48E2A6`;
background['green_bdot'  ] = `#48E2A6`;
background['green'       ] = '#A7DD28';
background['green_dot'   ] = '#A7DD28';
background['yellow'      ] = '#DAE000';
background['yellow_dot'  ] = '#DAE000';
background['yellow_l'    ] = '#FFCC00';
background['yellow_ldot' ] = '#FFCC00';
background['blue'        ] = '#487FFF';
background['blue_dot'    ] = '#487FFF';
background['blue_l'      ] = '#03C4EB';
background['blue_ldot'   ] = '#03C4EB';
background['blue_d'      ] = '#2332EC';
background['blue_ddot'   ] = '#2332EC';
background['org'         ] = '#FFB039';
background['org_dot'     ] = '#FFB039';
background['red'         ] = '#F58080';
background['red_dot'     ] = '#F58080';
background['coffee'      ] = '#C78C52';
background['coffee_dot'  ] = '#C78C52';
background['gray'        ] = '#9BB9E2';
background['gray_dot'    ] = '#9BB9E2';

rgbcolor['purple_b'    ] = 'rgb(61,69,174,0.5)';
rgbcolor['purple_bdot' ] = 'rgb(61,69,174,0.5)';
rgbcolor['purple_l'    ] = 'rgb(117,131,255,0.5)';
rgbcolor['purple_ldot' ] = 'rgb(117,131,255,0.5)';
rgbcolor['green_b'     ] = 'rgb(72,226,166,0.5)';
rgbcolor['green_bdot'  ] = 'rgb(72,226,166,0.5)';
rgbcolor['green'       ] = 'rgb(167,221,40,0.5)';
rgbcolor['green_dot'   ] = 'rgb(167,221,40,0.5)';
rgbcolor['yellow'      ] = 'rgb(218,224,0,0.5)';
rgbcolor['yellow_dot'  ] = 'rgb(218,224,0,0.5)';
rgbcolor['yellow_l'    ] = 'rgb(255,204,0,0.5)';
rgbcolor['yellow_ldot' ] = 'rgb(255,204,0,0.5)';
rgbcolor['blue'        ] = 'rgb(72,127,255,0.5)';
rgbcolor['blue_dot'    ] = 'rgb(72,127,255,0.5)';
rgbcolor['blue_l'      ] = 'rgb(3,196,235,0.5)';
rgbcolor['blue_ldot'   ] = 'rgb(3,196,235,0.5)';
rgbcolor['blue_d'      ] = 'rgb(35,50,236,0.5)';
rgbcolor['blue_ddot'   ] = 'rgb(35,50,236,0.5)';
rgbcolor['org'         ] = 'rgb(255,176,57,0.5)';
rgbcolor['org_dot'     ] = 'rgb(255,176,57,0.5)';
rgbcolor['red'         ] = 'rgb(245,128,128,0.5)';
rgbcolor['red_dot'     ] = 'rgb(245,128,128,0.5)';
rgbcolor['coffee'      ] = 'rgb(199,140,82,0.5)';
rgbcolor['coffee_dot'  ] = 'rgb(199,140,82,0.5)';
rgbcolor['gray'        ] = 'rgb(155,185,226,0.5)';
rgbcolor['gray_dot'    ] = 'rgb(155,185,226,0.5)';

window.financialCharts['income'   ] = ['income'];
window.financialCharts['equity'   ] = ['equity'];
window.financialCharts['cash_flow'] = ['cash_flow'];
window.financialCharts['financial'] = ['financial'];
window.financialCharts['sales'    ] = ['region', 'layer', 'application'];

window.saveAsImage = function(element, filename, type){
    $(element).removeClass('spi_box');
    html2canvas(element).then(canvas => {
        $(element).addClass('spi_box');
        let image = canvas.toDataURL(type);
        let link  = document.createElement('a');
        link.href     = image;
        link.download = filename;
        link.target   = '_blank';
        link.click();
    });
}

window.saveAsPdf = function(element, chart, url, filename, type){

    showLoadingDialog();

    html2canvas(element).then(canvas => {
        let search       = $('input[name="search"]').val();
        let base64_image = canvas.toDataURL(type);
        $.ajax({
            type: 'post',
            url : url,
            data: {'chart' : chart, 'search' : search, 'base64_image' : base64_image},
            dataType: 'json',
            success: function(response){
                hideLoadingDialog();
                var link = document.createElement('a');
                link.href = response.filename;
                //link.download = filename;
                link.target   = '_blank';
                link.click();
            },
            error: function(error){
                console.log(error);
            }
        });
    });
}

window.bindLegendsClickEvent = function(chart,element){
    $(element).find('.rd_legend_click').on('click',function(){
        let data_key = $(this).data('key');
        let is_data_show = chart.isDatasetVisible(data_key);
        if(is_data_show === true) {
            $(this).css('text-decoration', 'line-through');
        }
        if(is_data_show === false) {
            $(this).css('text-decoration', 'none');
        }
        chart.setDatasetVisibility(data_key, !is_data_show);
        chart.update();
    });
}

